import React from 'react';

interface CustomIconTicketProps extends React.SVGProps<SVGSVGElement> {}

export function CustomIconTicket({ width, height, ...props }: CustomIconTicketProps) {
  return (
    <svg
      width={width || 18}
      height={height || 18}
      viewBox="2 3 20 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M19.0684 4.9502C20.1619 4.95029 21.0507 5.83908 21.0508 6.93262V9.86523C21.0508 10.1611 20.8038 10.3835 20.543 10.4746C19.9949 10.6642 19.6016 11.1866 19.6016 11.7988C19.6017 12.4109 19.995 12.9325 20.543 13.1221C20.8038 13.2132 21.0508 13.4355 21.0508 13.7314V16.6641C21.0508 17.7577 20.162 18.6474 19.0684 18.6475H5.53809C4.44449 18.6473 3.55566 17.7577 3.55566 16.6641V13.7314C3.55566 13.4355 3.80265 13.2132 4.06348 13.1221C4.61144 12.9325 5.00475 12.4109 5.00488 11.7988C5.00488 11.1866 4.61159 10.6642 4.06348 10.4746C3.80265 10.3835 3.55566 10.1611 3.55566 9.86523V6.93262C3.55578 5.8391 4.44457 4.95032 5.53809 4.9502H19.0684ZM5.53809 6.5C5.30011 6.50012 5.10559 6.69464 5.10547 6.93262V9.26074C5.97295 9.77415 6.55469 10.7187 6.55469 11.7988C6.55458 12.8785 5.97263 13.8243 5.10547 14.335V16.6641C5.10547 16.9021 5.30004 17.0975 5.53809 17.0977H19.0684C19.3064 17.0976 19.501 16.9022 19.501 16.6641V14.335C18.6339 13.8215 18.0519 12.8786 18.0518 11.7988C18.0518 10.7188 18.6334 9.77135 19.501 9.26074V6.93262C19.5009 6.69462 19.3064 6.50009 19.0684 6.5H5.53809Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.1"
      />
      <path
        d="M8.80859 12.3967H12.7002C12.9717 12.3967 13.1893 12.6145 13.1895 12.886C13.1895 13.1576 12.9718 13.3752 12.7002 13.3752H8.80859C8.53699 13.3752 8.31934 13.1576 8.31934 12.886C8.31944 12.6145 8.53706 12.3967 8.80859 12.3967ZM8.80859 9.92407H15.5752C15.8466 9.92425 16.0635 10.1418 16.0635 10.4133C16.0634 10.6847 15.8466 10.9024 15.5752 10.9026H8.80859C8.53706 10.9026 8.31945 10.6848 8.31934 10.4133C8.31934 10.1417 8.53699 9.92407 8.80859 9.92407Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="0.638724"
      />
    </svg>
  );
}
